import ServiceFromItem from '../../../Domain/ServiceFromItem';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FigmaButton from '../../../Elements/FigmaButton';
import OverWindow from '../../../Elements/TabList/OverWindow';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import ServiceItemService from '../../../Services/ServiceItemService';
import ServiceService from '../../../Services/serviceService';
import ServiceSearchParams from './ServiceSearchParams';
import React from 'react';

export default class ChooseServicePanel extends React.Component {
  static defaultProps = {
    clickOnCancel: () => {},
    clickOnSubmit: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
      selected: {},
      saving: false,
      searchItem: new ServiceSearchParams(),
    };

    ServiceFromItem.clickOnSelect = this.clickOnSelect.bind(this);
  }

  clickOnSelect(item) {
    const templist = [...this.state.itemList];
    templist.forEach((element) => {
      element.Selected = element.ServiceId === item.ServiceId ? !element.Selected : false;
    });
    this.setState({
      itemList: templist,
      selected: { ...item },
    });
  }

  handleOnSubmit() {
    this.setState({ saving: true });
    ServiceItemService.GetServiceBySelection(this.state.selected)
      .then((item) => {
        this.props.clickOnSubmit(item);
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: CSP38. Service could not be found!');
        this.setState({ saving: false });
      });
  }

  renderCancelAndSubmitButtons() {
    return (
      <ButtonFooterContainer>
        <FigmaButton
          className='applySurveyPanelButton'
          label='Copy Service'
          icon={`fa-solid fa-copy${this.state.saving ? ' fa-spin' : ''}`}
          disabled={this.state.saving || !this.state.itemList.find((f) => f.Selected)}
          type={ButtonTypeEnum.ExtraLargeNormal}
          color={ButtonColorsEnum.Primary}
          iconPosition={IconPositionEnum.Left}
          onClick={() => this.handleOnSubmit()}
        />
      </ButtonFooterContainer>
    );
  }

  render() {
    return (
      <OverWindow
        title={'Choose Service To Copy From'}
        clickOnCancel={() => {
          if (!this.state.saving) this.props.clickOnCancel(false);
        }}
        closeOnClickOutside={false}
        iconName='fa-solid fa-plus-circle'
        zIndex={1050}
        className='applySurveyPanel top-of-boxFigma'
        verticalScroll={false}
      >
        <div className='container-fluid verticalScrollForSearch height50vh'>
          <TabOfDataTable
            itemList={this.state.itemList}
            type={ServiceFromItem}
            serviceFunction={ServiceService.GetServiceFromList}
            changeOfItemListFunction={(itemList) => this.setState({ itemList })}
            convertDBItemsFunction={ServiceService.ConvertServiceFromDBItem}
            showSearchStrip={true}
            singleSearchLinePlaceholder='Search in Service, Opportunity, Client IDs and Names...'
            singleSearchLine={true}
            enableUrlPush={false}
            searchParamsType={ServiceSearchParams}
            clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
            searchItem={this.state.searchItem}
            isFilterDisabled={true}
            isRefreshDisabled={true}
          />
          {this.renderCancelAndSubmitButtons()}
        </div>
      </OverWindow>
    );
  }
}
